import { API } from 'aws-amplify';

export async function syncCustomTests(): Promise<void> {
  const apiName = process.env.NEXT_PUBLIC_ACADEMICS_API_NAME!;
  const path = 'api/testing/sync-custom-tests';
  await API.post(apiName, path, {});
}
